import React from 'react';
import Icon from '@ant-design/icons';
import { ButtonType, Button } from 'components/Controls/Button';
import { SizeType } from 'antd/lib/config-provider/SizeContext';
import CloseSvg from './close.svg';

type IconButtonProps = {
  size?: SizeType,
  iconSize?: number,
  onClick?: React.MouseEventHandler<HTMLElement>,
  className?: string,
};

export const CloseIcon = (props: any) => <Icon component={CloseSvg} {...props} />;

export const CloseIconButton = React.forwardRef<HTMLButtonElement | HTMLAnchorElement, IconButtonProps>(
  ({ size = 'medium', iconSize = 24, ...props }, ref) => (
    <Button
      ref={ref}
      type={ButtonType.OutlineIcon}
      icon={<CloseSvg width={iconSize} height={iconSize} />}
      size={size}
      {...props}
    />
  ),
);
CloseIconButton.displayName = 'CloseIconButton';
